import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../../common/api/ApiRequestAdapter";
import { apiService } from "../../../common/api/apiService";
import { HttpMethod } from "../../../common/api/http";
import { EntityIdObject, EntityObject, SearchPageRequest, SearchPageResult } from "../../../common/types";
import { serializeParams } from "../../../common/utils/apiUtils";
import { CommissionsSettingsRank, CreateUpdateCommissionsSettingsRank } from "./types";

const FILTER_COMMISSIONS_SETTINGS_RANKS = ApiRequestAdapter.create("/commissions-settings-ranks", HttpMethod.GET);
const CREATE_COMMISSIONS_SETTINGS_RANKS = ApiRequestAdapter.create("/commissions-settings-ranks", HttpMethod.POST);
const UPDATE_COMMISSIONS_SETTINGS_RANKS = ApiRequestAdapter.create("/commissions-settings-ranks/{0}", HttpMethod.PUT);
const DELETE_COMMISSIONS_SETTINGS_RANKS = ApiRequestAdapter.create(
  "/commissions-settings-ranks/{0}",
  HttpMethod.DELETE,
);

export const commissionsSettingsRanksApi = {
  filterCommissionsSettingsRanks: (
    request: SearchPageRequest,
  ): AxiosPromise<SearchPageResult<CommissionsSettingsRank>> => {
    return apiService.get(FILTER_COMMISSIONS_SETTINGS_RANKS.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  createCommissionsSettingsRanks: (
    request: CreateUpdateCommissionsSettingsRank,
  ): AxiosPromise<CommissionsSettingsRank> => {
    return apiService.post(CREATE_COMMISSIONS_SETTINGS_RANKS.url, request);
  },
  updateCommissionsSettingsRanks: (
    request: EntityObject<CreateUpdateCommissionsSettingsRank>,
  ): AxiosPromise<CommissionsSettingsRank> => {
    return apiService.put(UPDATE_COMMISSIONS_SETTINGS_RANKS.getParametrizedUrl(request.id), request.object);
  },
  deleteCommissionsSettingsRanks: (request: EntityIdObject): AxiosPromise => {
    return apiService.delete(DELETE_COMMISSIONS_SETTINGS_RANKS.getParametrizedUrl(request.id));
  },
};
